import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Common from 'pages/Settings/containers/Persons/Card/components/Content/ContentWrapper/Common/Common';
import Contacts from 'pages/Settings/containers/Persons/Card/components/Content/ContentWrapper/Contacts/Contacts';
import PassportData from 'pages/Settings/containers/Persons/Card/components/Content/ContentWrapper/PassportData/PassportData';
import { RegularWrapper } from 'components/common';

const ContentWrapper = forwardRef(
  ({
    value,
    onChange,
    error,
    isGuest,
    isAddEmployeePage,
    checkSelectedOptionsUser,
    setCheckSelectedOptionsUser,
    checkSelectedOptionsContactPerson,
    setCheckSelectedOptionsContactPerson,
    checkSelectedOptionsTraveller,
    setCheckSelectedOptionsTraveller,
  }) => {
    return (
      <RegularWrapper flow="column" gap="28px" margin="28px 0 0 0">
        <Common
          value={value}
          onChange={onChange}
          errors={error || []}
          isGuest={isGuest}
          isAddEmployeePage={isAddEmployeePage}
          checkSelectedOptionsUser={checkSelectedOptionsUser}
          setCheckSelectedOptionsUser={setCheckSelectedOptionsUser}
          checkSelectedOptionsContactPerson={checkSelectedOptionsContactPerson}
          setCheckSelectedOptionsContactPerson={setCheckSelectedOptionsContactPerson}
          checkSelectedOptionsTraveller={checkSelectedOptionsTraveller}
          setCheckSelectedOptionsTraveller={setCheckSelectedOptionsTraveller}
        />
        {checkSelectedOptionsTraveller.includes('canTravelling') && (
          <PassportData value={value} onChange={onChange} errors={error || []} />
        )}
        <Contacts value={value} onChange={onChange} errors={error || []} />
      </RegularWrapper>
    );
  },
);

ContentWrapper.propTypes = {
  isGuest: PropTypes.bool,
  isAddEmployeePage: PropTypes.bool,
  onChange: PropTypes.func,
  setCheckSelectedOptionsUser: PropTypes.func,
  setCheckSelectedOptionsContactPerson: PropTypes.func,
  setCheckSelectedOptionsTraveller: PropTypes.func,
  checkSelectedOptionsContactPerson: PropTypes.array,
  checkSelectedOptionsUser: PropTypes.array,
  value: PropTypes.array,
  error: PropTypes.array,
  checkSelectedOptionsTraveller: PropTypes.array,
};

export default ContentWrapper;
